import { render, staticRenderFns } from "./ReservationPurposeNew.vue?vue&type=template&id=6e04583b&scoped=true&"
import script from "./ReservationPurposeNew.vue?vue&type=script&lang=js&"
export * from "./ReservationPurposeNew.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPurposeNew.vue?vue&type=style&index=0&id=6e04583b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04583b",
  null
  
)

export default component.exports